import { createActions } from 'redux-actions';
import {
  REGISTER_INIT_REQUEST,
  REGISTER_INIT_SUCCESS,
  REGISTER_INIT_FAILURE,
  REGISTER_VERIFY_REQUEST,
  REGISTER_VERIFY_SUCCESS,
  REGISTER_VERIFY_FAILURE,
  REGISTER_CREATE_USER_REQUEST,
  REGISTER_CREATE_USER_SUCCESS,
  REGISTER_CREATE_USER_FAILURE,
  REGISTER_SET_ERROR,
} from '../constants';

export const {
  registerInitRequest,
  registerInitSuccess,
  registerInitFailure,

  registerVerifyRequest,
  registerVerifySuccess,
  registerVerifyFailure,

  registerCreateUserRequest,
  registerCreateUserSuccess,
  registerCreateUserFailure,

  registerSetError,
} = createActions({
  [REGISTER_INIT_REQUEST]: (payload) => payload,
  [REGISTER_INIT_SUCCESS]: (payload) => payload,
  [REGISTER_INIT_FAILURE]: (payload) => payload,

  [REGISTER_VERIFY_REQUEST]: (payload) => payload,
  [REGISTER_VERIFY_SUCCESS]: (payload) => payload,
  [REGISTER_VERIFY_FAILURE]: (payload) => payload,

  [REGISTER_CREATE_USER_REQUEST]: (payload) => payload,
  [REGISTER_CREATE_USER_SUCCESS]: (payload) => payload,
  [REGISTER_CREATE_USER_FAILURE]: (payload) => payload,

  [REGISTER_SET_ERROR]: (payload) => payload,
});
